import React, { useCallback } from "react"
import { useTranslations } from "modules/i18n/hooks/useTranslations"
import { usePageProps } from "common/hooks/data/usePageProps"
import type { AppProps } from "common/lib/getAppServerSideProps"
import { navigateWindowLocation } from "@theconversation/shared-libraries/windowLocation"

export const RegionDropdown = () => {
  const { activeRegions, regionCode } = usePageProps<AppProps>()
  const t = useTranslations("layout.header")
  const onRegionChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    navigateWindowLocation(`/${event.target.value}`)
  }, [])

  return (
    <div className="m-4">
      <label htmlFor="mobile-region-dropdown" className="mb-1 block text-sm font-bold">
        {t("edition")}:
      </label>
      <div className="group w-full rounded-sm border border-gray-400 p-2 hover:bg-gray-50 has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-blue-700">
        <select
          id="mobile-region-dropdown"
          value={regionCode}
          onChange={onRegionChange}
          className="w-full bg-white text-sm outline-none group-hover:bg-gray-50"
        >
          {activeRegions.map(({ code, nameInRegionLanguage }) => (
            <option value={code} key={code}>
              {nameInRegionLanguage}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
